import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    registrationForm: FormGroup;
    submitting = false;
    submitError = '';
    schoolsList: any[] = [];
    filteredSchoolsByRegion: any[] = [];
    schoolSearch = '';
    showDropdown = false;
    public eventName = '普通話問答比賽（中華薪傳·非遺常識篇）';
    public project = 'hklsc_pthyxs';
    constructor(
        private fb: FormBuilder,
        private apiService: ApiService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.registrationForm = this.fb.group({
            last_name: ['', Validators.required],
            first_name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]],
            verify_password: ['', Validators.required],
            affiliation: ['', Validators.required],
            pics: [false, Validators.requiredTrue],
            agree_marketing: [false]
        }, { validators: this.passwordsMatch });
    }

    ngOnInit(): void {
        this.project = this.apiService.project;
        if (this.apiService.project == 'hklsc_ccec'){
            this.eventName = '全港幼兒和小學生普通話評測挑戰賽';
        }
        this.route.queryParams.subscribe((params: Record<string, string>) => {
            this.registrationForm.patchValue({
                last_name: params['last_name'] || '',
                first_name: params['first_name'] || '',
                email: params['email'] || '',
                phone: params['phone'] || '',
                affiliation: params['affiliation'] || '',
                agree_marketing: params['agree_marketing'] === 'true'
            });
            if (params['affiliation']) {
                this.schoolSearch = params['affiliation'];
            }
        });
        this.loadSchools();
    }

    private passwordsMatch(formGroup: FormGroup) {
        const password = formGroup.get('password')?.value;
        const verifyPassword = formGroup.get('verify_password')?.value;
        return password === verifyPassword ? null : { passwordMismatch: true };
    }

    loadSchools(): void {
        this.apiService.getSchoolList().subscribe({
            next: list => {
                this.schoolsList = list;
                this.groupSchoolsByRegion(list);
            },
            error: () => {
                this.filteredSchoolsByRegion = [];
            }
        });
    }

    private groupSchoolsByRegion(schools: any[]): void {
        const regionMap = new Map();

        schools.forEach(school => {
            if (!regionMap.has(school.region)) {
                regionMap.set(school.region, new Map());
            }
            if (!regionMap.get(school.region).has(school.district)) {
                regionMap.get(school.region).set(school.district, []);
            }
            regionMap.get(school.region).get(school.district).push(school);
        });

        this.filteredSchoolsByRegion = Array.from(regionMap.entries()).map(([region, districts]) => ({
            region,
            districts: Array.from(districts.entries()).map(([district, schools]) => ({
                district,
                schools
            }))
        }));
    }

    filterSchools(): void {
        const search = this.schoolSearch.trim().toLowerCase();
        if (!search) {
            this.groupSchoolsByRegion(this.schoolsList);
            return;
        }

        const filtered = this.schoolsList.filter(school =>
            school.schoolName.toLowerCase().includes(search)
        );
        this.groupSchoolsByRegion(filtered);
    }

    selectSchool(name: string): void {
        this.registrationForm.patchValue({ affiliation: name });
        this.schoolSearch = name;
        this.showDropdown = false;
    }

    onSchoolSearch(value: string): void {
        this.schoolSearch = value;
        this.registrationForm.patchValue({ affiliation: value });
        this.showDropdown = true;
        this.filterSchools();
    }

    onDropdownBlur(): void {
        setTimeout(() => {
            this.showDropdown = false;
        }, 200);
    }

    submit(): void {
        if (this.registrationForm.invalid) {
            this.registrationForm.markAllAsTouched();
            return;
        }
        this.submitting = true;
        this.submitError = '';

        const data = {
            loginDomain: 'hklsc',
            school_id: 69199,
            tag_id: 70831,
            email: this.registrationForm.value.email.toLowerCase().trim(),
            phone: this.registrationForm.value.phone,
            password: this.registrationForm.value.password,
            origin: window.location.origin,
            first_name: this.registrationForm.value.first_name,
            last_name: this.registrationForm.value.last_name,
            affiliation: this.registrationForm.value.affiliation,
            agree_marketing: this.registrationForm.value.agree_marketing
        };

        this.apiService.postRegistration(data).subscribe({
            next: response => {
                if (response && response.status == 'success') {
                    this.router.navigate(['/registration/success'], {
                        queryParams: {
                            email: data.email,
                            uuid: response.data?.uuid || ''
                        }
                    });
                } else {
                    this.submitError = response?.msg || '註冊失敗，請稍後重試。';
                }
                this.submitting = false;
            },
            error: err => {
                this.submitError = err?.error?.msg || '註冊失敗，請稍後重試。';
                this.submitting = false;
            }
        });
    }
}
